import { render, staticRenderFns } from "./RelatedMap.vue?vue&type=template&id=37fc7957&scoped=true&"
import script from "./RelatedMap.vue?vue&type=script&lang=js&"
export * from "./RelatedMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fc7957",
  null
  
)

export default component.exports